import styled, { css } from "styled-components";
import { colors } from "../../constants";
import { NavLink as Link } from "react-router-dom";

const stylesLink = css`
  display: flex;
  font-size: 12px;
  text-align: center;
  position: relative;
  align-items: center;
  text-decoration: none;
  flex-direction: column;
  justify-content: center;
`;

export const ItemLink = styled.div<{ color?: string }>`
  ${stylesLink}
  /* position: absolute; */
  color: ${(props) => props?.color} !important;
`;

export const NavLink = styled(Link) <{ color?: string }>`
  ${stylesLink};
  color: ${(props) => props?.color} !important;
`;

export const MenuContainer = styled.nav<{$color?: string}>`
  width: 100%;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 99;
  position: fixed;
  margin-left: auto;
  margin-right: auto;
  padding-top: 12px;
  padding-bottom: 10px;
  max-width: var(--mobile);
  background-color: ${(props) => props?.$color || colors.brand.grafite};
  box-shadow: 0px -10px 10px 0px ${colors.shadown1};
  transition: all 0.15s;
`;

export const Content = styled.div`
  gap: 18px;
  width: 100%;
  padding-bottom: 5px;
  position: relative;
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;

export const Icon = styled.div`
  margin-bottom: 4px;
`;

export const SelectedBar = styled.div<{$color?: string}>`
  top: -12px;
  width: 100%;
  height: 4px;
  position: absolute;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${(props) => props?.$color || colors.brand.yellow};
`;

export const MenuBoxDecoration = styled.img`
  position: absolute;
  width: 100%;
  left: 0;
  top: -10px;
  z-index: 10;
`;

export const MenuRightDecoration = styled.img`
  position: absolute;
  right: 0;
  top: -60%;
`;

export const LoggedRCAContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  padding: 15px 20px;
  width: 100%;
  max-width: var(--mobile);

  position: fixed;
  bottom: 67.5px;

  z-index: 99;

  background-color: ${colors.alert.red200};
  color: ${colors.brand.white};

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

`;

export const LoggedRCA = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.brand.white};

  small{
    font-size: 12px;
    font-weight: 400;
  }

  strong{
    font-size: 16px;
    font-weight: 600;
  }
`;

export const LogoutRCA = styled.button`
  background: none;
  border: none;
  color: ${colors.brand.white};
  cursor: pointer;

  text-align: right;
  flex-grow: 1;

/* 
  &:hover {
    opacity: 0.8;
  } */
`;